'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// ../~/math-intrinsics/min.js
// module id = 1862
// module chunks = 1